import { render, staticRenderFns } from "./app.vue?vue&type=template&id=459b8cbe&scoped=true&lang=pug&"
var script = {}
import style0 from "./app.vue?vue&type=style&index=0&id=459b8cbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459b8cbe",
  null
  
)

component.options.__file = "app.vue"
export default component.exports